<script setup>
import { TYPES as adminTool } from '@/constants/AdminTool'
import { useCustomerStore } from '@/stores/customer'
import { storeToRefs } from 'pinia'
import { defineAsyncComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import TheAuthentication from '../components/basic/organisms/TheAuthentication.vue'

const TheFooter = defineAsyncComponent(
  () => import('@/components/basic/organisms/TheFooter.vue')
)
const MultiTools = defineAsyncComponent(
  () => import('@/components/basic/molecules/MultiTools.vue')
)
const Tool = defineAsyncComponent(
  () => import('@/components/basic/atoms/Tool.vue')
)

const router = useRouter()
const route = useRoute()

const customerStore = useCustomerStore()
const { customerIsAdmin } = storeToRefs(customerStore)

const success = async () => {
  await router.push(route.query.redirect_uri || '/')
}
</script>

<template>
  <div id="content">
    <VContainer class="d-flex justify-center pa-0 pa-sm-3">
      <VSheet max-width="600" class="w-100">
        <TheAuthentication use-hard-redirects @success="success" />
      </VSheet>
    </VContainer>
    <TheFooter />
    <MultiTools id="fixed-tools" v-if="customerIsAdmin">
      <Tool :type="adminTool.TRANSLATE_MODE" />
      <Tool :type="adminTool.SHOW_ELBWALKER_USER_DATA" />
    </MultiTools>
  </div>
</template>
